/**
 * The person a member is racing on a challenge board.
 *
 * First place races the person behind them. Everyone else races the person
 * one place above. The count is the step gap to that person, from the full
 * board, so a rank below the first page still has a number.
 */
/** The adjacent rival for a known row, when that neighbor is in `people`. */
export function rivalBeside(me, people) {
    const other = me.rank === 1
        ? people.find((person) => person.rank === me.rank + 1)
        : people.find((person) => person.rank === me.rank - 1);
    if (!other || other.rank === me.rank)
        return null;
    const pictured = {
        displayName: other.displayName,
        rank: other.rank,
        initials: other.initials ?? null,
        avatarUrl: other.avatarUrl ?? null,
        avatarColor: other.avatarColor ?? null,
    };
    if (me.rank === 1) {
        return {
            direction: "ahead",
            steps: Math.max(0, me.score - other.score),
            ...pictured,
        };
    }
    return {
        direction: "behind",
        steps: Math.max(0, other.score - me.score),
        ...pictured,
    };
}
function picture(other) {
    return {
        displayName: other.displayName,
        rank: other.rank,
        initials: other.initials ?? null,
        avatarUrl: other.avatarUrl ?? null,
        avatarColor: other.avatarColor ?? null,
    };
}
/**
 * Both neighbours on the track: the nearest rank above and the nearest rank
 * below. Tied ranks leave holes in the sequence, so this takes the closest
 * rank on each side rather than exactly one place away.
 */
export function rivalsAround(me, people) {
    let above = null;
    let below = null;
    for (const person of people) {
        if (person.rank < me.rank && (!above || person.rank > above.rank))
            above = person;
        if (person.rank > me.rank && (!below || person.rank < below.rank))
            below = person;
    }
    return {
        ahead: above
            ? { direction: "behind", steps: Math.max(0, above.score - me.score), ...picture(above) }
            : null,
        behind: below
            ? { direction: "ahead", steps: Math.max(0, me.score - below.score), ...picture(below) }
            : null,
    };
}
/** The viewer's adjacent rival on a fully ranked board. */
export function nearestChallengeRival(people, viewerUserId) {
    const me = people.find((person) => person.userId === viewerUserId);
    if (!me)
        return null;
    return rivalBeside(me, people);
}
//# sourceMappingURL=nearest-rival.js.map